import { swCacheService } from "../hmodules/harri-main/services/sw-cache.service.js";

window.CoreReaderAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.coreReaderAPIServersBaseURL);

    self.getEmployeeAllNotification = function(groupId) {
        var defer = $q.defer();

        _protected.request('groups/' + groupId + '/unread_message_count_employer', 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getBrandsParents = async (brandIds) => {
        const url = `brands/parents?ids=${brandIds}`;
        const response = await _protected.request(url, 'GET');
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getAppMsgsUpdates = function(applicationId, messageId) {
        var defer = $q.defer();

        _protected.request('application_message_updates/' + applicationId + '/' + messageId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getBrandsUpdates = function(groupId, includeArchived) {
        var defer = $q.defer();
        var optionalParameter = '';
        if (includeArchived) {
            optionalParameter += '?include_archived=true';
        }

        _protected.request('groups/' + groupId + '/employer/message_board_counts' + optionalParameter, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getMemberProfile = function(memberId) {
        var defer = $q.defer();

        _protected.request('profile/member/' + memberId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getEmployeeBusinessSettings = function (businessId) {
        var defer = $q.defer();

        _protected.request('teamlive/employees/brands/' + businessId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getPreviewJobDetails = function (brandId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/preview', 'POST', payload)
            .then(function (result) {
                if (result && result.data && result.data.data) {
                    defer.resolve(result.data.data);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getJobAssignees = async (onlyActiveJobs) => {
        const params = {
            only_active_jobs: (onlyActiveJobs !== undefined) ? onlyActiveJobs : true,
        };
        const response = await _protected.request(`users/jobs/assignees`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getUserAssignedJobs = async (payload) => {
        const response = await _protected.request(`users/jobs/search`, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getUserBrands = cacheService.cache(function (groupId, includeServices, includePermissions, includeArchived) {
        var defer = $q.defer();

        const params = new URLSearchParams();

        if (includeServices) {
            params.set('include_services', true);
        }

        if (includePermissions) {
            params.set('include_permissions', true);
        }

        if (includeArchived) {
            params.set('include_archived', true);
        }

        const query = params.toString();
        
        _protected.request(`groups/${groupId}/brands${query ? `?${query}` : ''}`, {
            method: 'GET',
            headers: swCacheService.getCacheHeader(`stale-while-revalidate`)
        })
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    })[0];

    self.getListOfEnterprises = function (type) {
        var defer = $q.defer();
        var params = {
            type: type
        }
        _protected.request('apprenticeship_jobs/brands', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.getTalentPoolUserInfo = async (brandId, userId) => {
        const response = await _protected.request(`talent-pool/brands/${brandId}/users/${userId}/info`, 'GET');

        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.getTalentScoutRedirectionURL = async (brandId, code) => {
        const params = {
            code_id: code
        }
        const response = await _protected.request(`public/brands/${brandId}/talent_scout_redirect_url`, 'GET', params);

        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.getTalentPoolJobs = function (brandId) {
        let defer = $q.defer();
        _protected.request(`public/brands/${brandId}/talent-pool/jobs`, 'GET')
            .then(response => {
                if (response?.data?.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }).catch((err) => {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.getBrandTimeZoneDetails = async (brandId) => {
        const response = await _protected.request(`brands/${brandId}/timezone`, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
     };

    self.getBrandBusinessSettings = function (brandId) {
        let defer = $q.defer();
        _protected.request(`brands/${brandId}/business_settings`, 'GET')
            .then((res) => {
                if (res?.data?.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.getCountOfBrands = async function (brandId, brandIds, countedType) {
        let payload = {
            "brands_ids": brandIds,
            "counted_type": countedType
        };

        const response = await _protected.request(`brands/${brandId}/count`, "POST", payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getEEOSettings = async (brandId) => {
        const response = await _protected.request(`brands/${brandId}/eeo_settings`, 'GET');

        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }

        throw response;
    };

    self.checkFinancialUnit = async function (brandId) {
        const response = await _protected.request(`brands/${brandId}/financial_unit/check`, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };
});
